import { GlyphProps, IconProps } from '@atlaskit/icon';
import { sizes } from '@atlaskit/logo/constants';
import { colors, elevation } from '@atlaskit/theme';
import React from 'react';
import styled from 'styled-components';

import { IconType } from '../../../clients/sites/model';
import { onMobile } from '../../mobile/responsive';
import { iconContainerStyle } from '../style';

interface Props {
  icon: IconType;
}

export type IconPropsWithOptionalLabel = Omit<IconProps, 'label'> & {
  label?: string;
};

const iconProps: IconProps & { iconColor: string } = {
  iconColor: colors.N0,
  label: '',
  size: 'xlarge',
};

export const IconContainer = styled.div`
  ${iconContainerStyle};

  background-color: ${colors.B400};

  ${elevation.e200};
  transition: box-shadow 0.25s;
`;

export default class ProductIcon extends React.Component<Props> {
  render() {
    const Icon = this.props.icon;
    return (
      <IconContainer>
        <Icon {...iconProps} />
      </IconContainer>
    );
  }
}

const StyledProductIconImage = styled.img`
  height: ${sizes.xlarge}px;
  width: ${sizes.xlarge}px;

  ${onMobile(`
      height: ${sizes.small}px;
      width: ${sizes.small}px;
    `)}
`;

export const createImageIcon = (url: string): IconType => (props: IconPropsWithOptionalLabel) => {
  return <StyledProductIconImage src={url} />;
};

export const createIcon = (
  icon:
    | React.ComponentClass<GlyphProps>
    | React.ComponentType<IconPropsWithOptionalLabel>
    | React.NamedExoticComponent<IconProps>,
): IconType => (props: IconPropsWithOptionalLabel) => {
  const Icon = icon;
  return <Icon {...props} label={props.label || ''} />;
};
